<template>
    <div class="wrapper">
        <div class="left">
            <template v-if="array.video_type == 'video'">
                <Plyr :options="{ controls: ['play', 'progress', 'mute', 'volume', 'fullscreen'] }">
                    <video>
                    <source :src="`${this.$store.state.base_directory}${array.local_video.replace(/^public\//, '')}`" type="video/mp4" />
                    </video>
                </Plyr>
                <!-- <video 
                class=""
                ref="videoPlayer" :src="`${this.$store.state.base_directory}${array.local_video.replace(/^public\//, '')}`">
                </video> -->
            </template>
            <template v-else>
                <iframe
                :src="array.iframe_video"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
                ></iframe>
            </template>

        </div>
        <div class="right" v-html="array.text">
        </div>
    </div>
</template>

<script>
import "vue-plyr/dist/vue-plyr.css";
import Plyr from "vue-plyr";
    export default {
        components: {
            Plyr,
        },
        props: {
            array: [Array, Object],
        },
        mounted() {
            if (this.$refs.videoPlayer) {
                this.$refs.videoPlayer.volume = 0.5; // Установим громкость на 50%
            }
        }
    }
</script>

<style scoped>
.wrapper{
    display: flex;
    gap: 20px;
    justify-content: space-between;
    padding-top: 114px;
}
.video-js .vjs-big-play-button {
  background-color: #ff5733 !important;
  border-radius: 50%;
}

.video-js .vjs-control-bar {
  background: rgba(0, 0, 0, 0.7) !important;
}

/* Скрыть логотип Video.js */
.video-js .vjs-icon-placeholder:before {
  content: "";
}
.left{
    width: 42.5%;
}
.right{
    width: 49%;
    
}
.right p{
    /* Paragraph/P2: 20px Regular */
color: rgb(29, 29, 52);
font-size: 20px;
font-weight: 400;
line-height: 140%;
letter-spacing: 0%;
text-align: left;
}
video{
    width: 100%;
    max-height: 407px;
}
iframe {
width: 100%;
max-height: 407px;
height: 407px;
}
@media (max-width: 768px) {
 .wrapper{
    flex-direction: column;
 }
 .left, .right{
    width: 100%;
 }
}
</style>